import React from 'react';
import { Link } from 'react-router-dom';
import './Supplier.css';

const products = [
  {
    id: 1,
    name: "Solar Panels",
    image: "/images/supplier/image1.jpeg",
    category: "Solar Systems",
    description: "High-efficiency monocrystalline solar panels 300W-500W"
  },
  {
    id: 2,
    name: "Solar Inverters",
    image: "/images/supplier/image2.jpeg",
    category: "Solar Systems",
    description: "Pure sine wave inverters with smart monitoring"
  },
  {
    id: 3,
    name: "Solar Batteries",
    image: "/images/supplier/image3.jpeg",
    category: "Solar Systems",
    description: "Deep cycle lithium-ion batteries for solar storage"
  },
  {
    id: 4,
    name: "CCTV Cameras",
    image: "/images/supplier/image4.jpeg",
    category: "Security",
    description: "HD/IP cameras with night vision and motion detection"
  },
  {
    id: 5,
    name: "DVR/NVR Systems",
    image: "/images/supplier/image5.jpeg",
    category: "Security",
    description: "Multi-channel digital recorders with remote access"
  },
  {
    id: 6,
    name: "Alarm Systems",
    image: "/images/supplier/image6.jpeg",
    category: "Security",
    description: "Wireless alarm kits with door/window sensors"
  },
  {
    id: 7,
    name: "Electric Fence",
    image: "/images/supplier/image7.jpeg",
    category: "Security",
    description: "High-tensile electric fence energizers and accessories"
  },
  {
    id: 8,
    name: "Network Routers",
    image: "/images/supplier/image8.jpeg",
    category: "Networking",
    description: "High-speed routers for home and office connectivity"
  },
  {
    id: 9,
    name: "Network Cables",
    image: "/images/supplier/image9.jpeg",
    category: "Networking",
    description: "Cat6/Cat7 Ethernet cables and fiber optic solutions"
  },
  {
    id: 10,
    name: "TV Mounts",
    image: "/images/supplier/image10.jpeg",
    category: "Installation",
    description: "Full-motion TV wall mounts for all screen sizes"
  },
  {
    id: 11,
    name: "Electrical Panels",
    image: "/images/supplier/image11.jpeg",
    category: "Electrical",
    description: "Distribution boards and circuit breakers for safety"
  },
  {
    id: 12,
    name: "Smart Switches",
    image: "/images/supplier/image12.jpeg",
    category: "Electrical",
    description: "WiFi-enabled smart light switches and dimmers"
  }
];

const Supplier = () => {
  return (
    <section className="supplier-section">
      <div className="supplier-container">
        {/* Section Header */}
        <div className="supplier-header">
          <h4 className="supplier-subtitle">Our Products</h4>
          <h1 className="supplier-title">Quality Equipment & Products For Your Needs</h1>
          <p className="supplier-description">
            Musa Electrical also supplies high-quality equipment and products related to our services. 
            From solar panels to security systems, we provide reliable products you can trust.
          </p>
        </div>

        {/* Products Grid */}
        <div className="supplier-grid">
          {products.map((product, index) => (
            <div 
              className={`supplier-card slide-in ${index % 2 === 0 ? 'from-left' : 'from-right'}`} 
              key={product.id}
            >
              <div className="product-image">
                <img 
                  src={process.env.PUBLIC_URL + product.image} 
                  alt={product.name} 
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="200" fill="%231a1a2e"><rect width="400" height="200"/><text x="50%" y="50%" fill="%23ffd700" font-size="18" text-anchor="middle" dy=".3em">' + product.name + '</text></svg>';
                  }}
                />
                <span className="product-category">{product.category}</span>
              </div>
              <div className="product-info">
                <h3>{product.name}</h3>
                <p>{product.description}</p>
                <Link to="/contact" className="product-btn">Order Now</Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="supplier-cta">
          <h2>Ready to Purchase?</h2>
          <p>Contact us today to order quality electrical products at competitive prices.</p>
          <Link to="/contact" className="cta-btn">Order or Buy From Us</Link>
        </div>
      </div>
    </section>
  );
};

export default Supplier;
